import {type BoxTags, Paper as GWCPaper} from '@gwc/main'
import {type ReactElement} from 'react'
import clsx from 'clsx'

import * as classes from './Paper.classes'
import type {PaperProps, AnyPaperProps} from './types'

export function Paper<C extends Function | BoxTags> (props: PaperProps<C>): ReactElement {
  const { item, float, className: classNameProp, ...paperProps } = props

  if (float) {
    return (
      <GWCPaper {...paperProps} className={clsx(float && classes.float[float], classNameProp)}/>
    )
  }

  return (
    <GWCPaper
      {...paperProps}
      className={clsx(
        item && classes.item,
        item === 'header' && classes.header,
        item === 'footer' && classes.footer,
        classNameProp,
      )}
      mt={getMarginTop(props)}
      flexDirection={getFlexDirection(props)}
      flexGrow={getFlexGrow(props)}
    />
  )
}

function getMarginTop (props: AnyPaperProps): AnyPaperProps['mt'] {
  if ('mt' in props) {
    return props.mt
  }

  if (props.item) {
    if (props.item !== 'header') {
      return 'xs'
    }
  }
}

function getFlexDirection (props: AnyPaperProps): AnyPaperProps['flexDirection'] {
  if ('flexDirection' in props) {
    return props.flexDirection
  }

  if (props.item) {
    return 'column'
  }
}

function getFlexGrow (props: AnyPaperProps): AnyPaperProps['flexGrow'] {
  if ('flexGrow' in props) {
    return props.flexGrow
  }

  if (props.item) {
    if (props.item !== 'header') {
      return 1
    }
  }
}
